/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import e from "prop-types";
const n = class n extends t.Component {
  /**
   * @hidden
   */
  render() {
    return null;
  }
};
n.propTypes = {
  disabled: e.bool,
  contentClassName: e.string,
  children: e.oneOfType([e.element, e.node]),
  title: e.oneOfType([e.string, e.element, e.node])
};
let o = n;
export {
  o as TabStripTab
};
